import * as React from 'react'
import { Card, CardBody } from '../../../../components/card'
import styles from './promoNewCompanies.module.scss'
import { FormattedMessage, defineMessages } from 'react-intl'

const messages = defineMessages({
  heading: {
    defaultMessage: 'Dooers bokföringsprogram finns kvar precis som innan',
    id: 'start.new-companies-promo.heading',
  },
  lede: {
    defaultMessage: 'Vårt fantastiska bokföringsprogram kommer fortsätta att finnas kvar.',
    id: 'start.new-companies-promo.lede',
  },
})

const PromoNewCompanies = () => {
  return (
    <Card className={styles.promoCard}>
      <CardBody>
        <FormattedMessage tagName="h3" {...messages.heading} />
        <FormattedMessage tagName="p" {...messages.lede} />
      </CardBody>
    </Card>
  )
}

export default PromoNewCompanies
